import { FC } from 'react';
import type { FloatingPosition } from '@mantine/core';
import { MdKey } from 'react-icons/md';
import Button from '@srm/ui/button';
import Tooltip from '@srm/ui/tooltip';
import { ACTION_KEY_TOOLTIP_Z_INDEX } from '@srm/ui/lib/zIndex';
import { copyText } from '@srm/ui/lib/clipboard';

export interface IActionKeyButtonProps {
    /** Тип действия — первая строка подсказки. */
    type: string;
    /** Ключ действия: копируется по нажатию. */
    actionKey: string;
    /** @default 'bottom' */
    position?: FloatingPosition;
    /** Размер значка ключа, px. @default 20 */
    iconSize?: number;
}

/**
 * Значок «Ключ кнопки» у действия (отладка вне PROD): подсказка с типом и ключом, нажатие копирует ключ. Нажатие не
 * доходит до кнопки или пункта действия, в котором значок стоит.
 */
const ActionKeyButton: FC<IActionKeyButtonProps> = ({ type, actionKey, position = 'bottom', iconSize = 20 }) => {
    return (
        <Tooltip
            position={position}
            interactive={false}
            background="black"
            zIndex={ACTION_KEY_TOOLTIP_Z_INDEX}
            label={`Тип: ${type}${actionKey ? `\nКлюч: ${actionKey}` : ''}`}
        >
            <Button
                variant="icon"
                size="auto"
                aria-label="Ключ кнопки"
                onClick={(event) => {
                    event.stopPropagation();
                    void copyText(actionKey);
                }}
                startAdornment={<MdKey size={iconSize} />}
            />
        </Tooltip>
    );
};

export default ActionKeyButton;
